module.exports = __webpack_public_path__ + "img/bannier_school_default_pic.6476546.jpg";